module.exports = __webpack_public_path__ + "static/media/beauty.e460e96d.jpg";